module.exports = __webpack_public_path__ + "static/media/RN-2025-01_preview.691ca634.jpg";